import {
  KeyboardArrowDown,
  Edit,
  CheckCircle,
  CheckCircleOutline,
} from "@material-ui/icons";
import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { connect } from "react-redux";
import noRecord from "../../../assets/img/no-record.png";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import {
  getbillingPlans,
  updateIsactiveIsdefaultFlag,
  checkplantoUser,
} from "../../../actions/BillingActions";

class BillingItems extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title: "Billing Plan",
      billingPlan: [],
      heading: "",
      firstPara: "",
      secondPara: "",
    };
  }
  columns = [
    {
      name: "Plan Name",
      selector: "PlanName",
      sortable: true,
      ignoreRowClick: true,
    },
    {
      name: "Shop owner",
      selector: "Shopowner",
      sortable: true,
      ignoreRowClick: true,
    },

    {
      name: "Status",
      selector: "Status",
      // sortable: true,
      width: "115px",
    },
    {
      name: "Default",
      selector: "Default",
      // sortable: true,
      width: "115px",
    },
    {
      name: "",
      selector: "action",
      right: true,
      ignoreRowClick: true,
      width: "10%",
    },
  ];
  componentWillMount() {
    this.getallBillingplan();
  }
  getallBillingplan() {
    this.setState({
      showLoader: true,
    });
    this.props.getbillingPlans().then((result) => {
      this.setState({
        billingPlan:
          Array.isArray(result.data) && result.data.length > 0
            ? result.data
            : [],
        showLoader: false,
      });
    });
  }
  DataOFParticularRow(data, type, status, billingPlan) {
    // check active for making default
    if (type === "Default") {
      if (status === true) {
        confirmAlert({
          customUI: ({ onClose }) => {
            return (
              <div className="">
                <div className="react-confirm-alert-body">
                  <h2>Confirmation</h2>
                  <p>There won't be a default plan. Do you want to continue?</p>
                  <div className="react-confirm-alert-button-group">
                    <button
                      onClick={() => {
                        let values = {
                          id: data,
                          type: type,
                          status: !status,
                        };
                        this.updateFlags(values);
                        onClose();
                      }}
                    >
                      {" "}
                      Yes{" "}
                    </button>
                    <button onClick={onClose}>No</button>
                  </div>
                </div>
              </div>
            );
          },
        });
      } else if (billingPlan.isActive === true) {
        // make it default
        let values = {
          id: data,
          type: type,
          status: !status,
        };
        this.updateFlags(values);
      } else {
        //show popup for making default you need to make it active
        confirmAlert({
          customUI: ({ onClose }) => {
            return (
              <div className="">
                <div className="react-confirm-alert-body">
                  <h2>Make Default</h2>
                  <p>
                    Please make plan active first then make it as a default.
                  </p>
                  <div className="react-confirm-alert-button-group">
                    <button onClick={onClose}>Close</button>
                  </div>
                </div>
              </div>
            );
          },
        });
      }
    } else {
      // check plan default for making deactive
      if (billingPlan.isDefault === true) {
        //please make other plan default than deactive that plan.
        confirmAlert({
          customUI: ({ onClose }) => {
            return (
              <div className="">
                <div className="react-confirm-alert-body">
                  <h2>Active / Deactive</h2>
                  <p>Please make other plan default then deactive that plan.</p>
                  <div className="react-confirm-alert-button-group">
                    <button onClick={onClose}>Close</button>
                  </div>
                </div>
              </div>
            );
          },
        });
      } else {
        let values = {
          id: data,
          type: type,
          status: !status,
        };
        this.updateFlags(values);
      }
    }
  }

  //check plan is set to user or not , before it going to status inactive.
  CheckplanUser(data, type, status, billingPlan) {
    this.props
      .checkplantoUser(billingPlan)
      .then((res) => {
        if (res.count === 0) {
          this.DataOFParticularRow(
            billingPlan._id,
            "Status",
            billingPlan.isActive,
            billingPlan
          );
        } else {
          //show popup that you cannot upate it.
          confirmAlert({
            customUI: ({ onClose }) => {
              return (
                <div className="">
                  <div className="react-confirm-alert-body">
                    <h2>Active / Deactive</h2>
                    <p>
                      You cannot make this plan status deactive , because total{" "}
                      {res.count} users are using this plan.
                    </p>
                    <div className="react-confirm-alert-button-group">
                      <button onClick={onClose}>Close</button>
                    </div>
                  </div>
                </div>
              );
            },
          });
        }
      })
      .catch((err) => {});
  }

  /**
   * @desc goto buyer agent's transactions
   */
  goToShopOwner(planid, planname) {
    this.props.history.push({
      pathname: "/AccountOwner",
      state: {
        id: planid,
        name: planname,
      },
    });
  }

  updateFlags(values) {
    this.props
      .updateIsactiveIsdefaultFlag(values)
      .then((res) => {
        this.getallBillingplan();
      })
      .catch((err) => {});
  }
  render() {
    let rows = [];
    for (var i = 0, len = this.state.billingPlan.length; i < len; i++) {
      let billingPlan = this.state.billingPlan[i];
      let data = {
        PlanName: billingPlan.PlanName,

        Shopowner:
          billingPlan.userCount != 0 ? (
            <Button
              variant="link"
              className="p-0"
              onClick={() =>
                this.goToShopOwner(billingPlan._id, billingPlan.PlanName)
              }
            >
              {" "}
              {billingPlan.userCount}
            </Button>
          ) : (
            0
          ),
        Status: billingPlan.isActive ? (
          <CheckCircle
            className="check"
            style={{ color: "green" }}
            onClick={() =>
              this.CheckplanUser(
                billingPlan._id,
                "Status",
                billingPlan.isActive,
                billingPlan
              )
            }
          />
        ) : (
          <CheckCircleOutline
            className="check-out"
            onClick={() =>
              this.DataOFParticularRow(
                billingPlan._id,
                "Status",
                billingPlan.isActive,
                billingPlan
              )
            }
          />
        ),
        Default: billingPlan.isDefault ? (
          <CheckCircle
            className="check"
            style={{ color: "green" }}
            onClick={() =>
              this.DataOFParticularRow(
                billingPlan._id,
                "Default",
                billingPlan.isDefault,
                billingPlan
              )
            }
          />
        ) : (
          <CheckCircleOutline
            className="check-out"
            onClick={() =>
              this.DataOFParticularRow(
                billingPlan._id,
                "Default",
                billingPlan.isDefault,
                billingPlan
              )
            }
          />
        ),

        // createdby: billingItems.createdby ? billingItems.createdby : "",
        // modifiedby: billingItems.modifiedby ? billingItems.modifiedby : "",

        action: (
          <div className="action-btns">
            <Button
              variant="transparent"
              onClick={() => {
                // this.props.history.push(`/BillingModule/EditbillingPlan`, {
                //   id: billingPlan._id,
                // });

                this.props.history.push({
                  pathname: "/BillingModule/EditbillingPlan",
                  state: {
                    id: billingPlan._id,
                  },
                });
              }}
            >
              <Edit />
            </Button>
          </div>
        ),
      };

      rows.push(data);
    }
    return (
      <div>
        <Row className="ml-0 mr-0 page-head-row page-head-row-big align-items-center">
          <Col xs="4">
            <h4 className="title-med mt-0 pt-1">{this.state.title}</h4>
          </Col>
          <Col align="right" className="contact-btn">
            <Button
              variant="primary"
              className="btn-blue btn-head"
              onClick={() => {
                this.props.history.push({
                  pathname: "/BillingModule/BillingPlans",
                });
              }}
            >
              Add Plans
            </Button>
          </Col>
        </Row>
        {this.state.showLoader ? (
          <div className="page-loader">
            <div className="page-loader-inner">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        ) : (
          <div className="dt-content-area">
            <DataTable
              columns={this.columns}
              data={rows}
              noDataComponent={
                <div className="no-transaction no-record no-datatable">
                  <div className="no-transaction-inner">
                    <img src={noRecord} alt="no record" />
                    <p>No Data Found</p>
                  </div>
                </div>
              }
              highlightOnHover={true}
              className="rdt-requests"
              sortIcon={<KeyboardArrowDown className="color-grey-1" />}
              onRowSelected={this.getSelectedRows}
            />

            {this.state.showLoader === true && (
              <div className="page-loader">
                <div className="page-loader-inner">
                  <div className="spinner-border" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

export default connect(
  mapStateToProps,
  {
    getbillingPlans,
    updateIsactiveIsdefaultFlag,
    checkplantoUser,
  }
)(BillingItems);
